import { COVERGO_SAAS_DEV } from "../consts.js"

export const avivauk = {
	"avivauk-uat-studio.quote.hk": {
		appConfig: {
			tenantId: "avivauk_uat",
			appId: "admin_portal"
		},
		envConfig: COVERGO_SAAS_DEV
	}
}
